export abstract class NotificationBase {
	notificationLimit = false;
	dailyLimit?: number;
	weeklyLimit?: number;
	monthlyLimit?: number;

	constructor(init?: Partial<NotificationBase>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
